import React from "react";
import { Navigate } from "react-router-dom";
import { useStoreState } from "easy-peasy";
import Topbar from "./Topbar";
import Meritlistadmincomponent from "./meritlistadmincomponent";
import "./admin.css";

function Meritlistadmin() {
  const isAuthenticated = useStoreState((state) => state.user.isAuthenticated);

  // Check if the user is authenticated, otherwise redirect to the login page
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  return (
    <div className="dashboard">
      <div className="dashboardtopbar">
        <Topbar />
      </div>
      <div className="main-content">
        <Meritlistadmincomponent />
      </div>
    </div>
  );
}

export default Meritlistadmin;
